<!--企业服务资源池管理系统-->
<template>
  <div class="resource-container">
    <header-index/>
    <div class="resource-content">
      <div class="resource-breadcrumb">
        <span>您当前位置:</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
              :to="{ path: '/cloudPlatform/platform?city=2&cityName='+childNode.name+'&cityCode='+childNode.cityCode+'&parentCityCode='+childNode.parentCityCode+'&pName='+childNode.name+'企业数字化服务云平台&parName=渝企服务云' }">
            服务平台
          </el-breadcrumb-item>
          <el-breadcrumb-item
              :to="{ path: '/cultivation/index?city=2&cityName='+childNode.name+'&cityCode='+childNode.cityCode+'&parentCityCode='+childNode.parentCityCode+'&pName='+childNode.name+'企业数字化服务云平台&parName=渝企服务云' }">
            企业培育
          </el-breadcrumb-item>
          <el-breadcrumb-item>企业服务资源池管理系统</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="resource-info">
        <p class="resource-title">企业服务资源池管理系统</p>
        <el-form :model="resourceForm" :rules="rules" label-position="right" ref="resourceForm0"
                 label-width="110px" class="resourceForm0">
          <el-form-item label="企业名称:" prop="businessName">
            <el-input v-model="resourceForm.businessName" style="width: 100%"/>
          </el-form-item>
          <el-form :inline="true" class="demo-form-inline resource-form" :rules="rules" :model="resourceForm"
                   label-width="110px"
                   ref="resourceForm1" label-position="right">
            <el-form-item label="法定代表人:" prop="legalPerson">
              <el-input v-model="resourceForm.legalPerson" :style="'width: '+inputWidth+'px;'"/>
            </el-form-item>
            <el-form-item label="手机:" prop="legalPhone">
              <el-input v-model="resourceForm.legalPhone" :style="'width: '+inputWidth+'px;'"/>
            </el-form-item>
            <el-form-item label="办公电话:">
              <el-input v-model="resourceForm.legalTelephone" :style="'width: '+inputWidth+'px;'"/>
            </el-form-item>
          </el-form>
          <el-form :inline="true" class="demo-form-inline resource-form" :rules="rules" :model="resourceForm"
                   label-width="110px"
                   ref="resourceForm2" label-position="right">
            <el-form-item label="联系人:" prop="contacts">
              <el-input v-model="resourceForm.contacts" :style="'width: '+inputWidth+'px;'"/>
            </el-form-item>
            <el-form-item label="手机:" prop="phone">
              <el-input v-model="resourceForm.phone" :style="'width: '+inputWidth+'px;'"/>
            </el-form-item>
            <el-form-item label="办公电话:">
              <el-input v-model="resourceForm.telephone" :style="'width: '+inputWidth+'px;'"/>
            </el-form-item>
          </el-form>
          <el-form :inline="true" class="demo-form-inline resource-form" :rules="rules" :model="resourceForm" label-width="110px"
                   ref="resourceForm3" label-position="right">
            <el-form-item label="年产值(万元):" prop="money">
              <el-input v-model="resourceForm.money" :style="'width:'+inputWidth2+'px;'"/>
            </el-form-item>
            <el-form-item label="企业人数:" prop="employees">
              <el-input v-model="resourceForm.employees" :style="'width:'+inputWidth2+'px;'"/>
            </el-form-item>
          </el-form>
          <el-form :inline="true" class="demo-form-inline resource-form" :rules="rules" :model="resourceForm" label-width="110px"
                   ref="resourceForm4" label-position="right">
            <el-form-item label="企业网站:" prop="website">
              <el-input v-model="resourceForm.website" :style="'width:'+inputWidth2+'px;'"/>
            </el-form-item>
            <el-form-item label="电子邮箱:" prop="email">
              <el-input v-model="resourceForm.email" :style="'width:'+inputWidth2+'px;'"/>
            </el-form-item>
          </el-form>
          <el-form :inline="true" class="demo-form-inline resource-form" :model="resourceForm" label-width="110px" ref="resourceForm5"
                   label-position="right">
            <el-form-item label="QQ:">
              <el-input v-model="resourceForm.qq" :style="'width:'+inputWidth2+'px;'"/>
            </el-form-item>
            <el-form-item label="邮编:">
              <el-input v-model="resourceForm.zipCode" :style="'width:'+inputWidth2+'px;'"/>
            </el-form-item>
          </el-form>
          <el-form-item label="注册地址:" prop="city" class="industry-select">
            <el-select v-model="resourceForm.province" placeholder="请选择" clearable @change="changeProvincial"
                       :style="resourceForm.province!=110000 && resourceForm.province!=120000 && resourceForm.province!=500000 && resourceForm.province!=310000 ? 'width: 12vw;margin-right: 56px;' : 'width: 16vw;margin-right: 160px;'">
              <el-option v-for="item in provincialCodeItem" :label="item.name" :value="item.id"/>
            </el-select>
            <el-select v-model="resourceForm.city" placeholder="请选择" clearable @change="changeCity"
                       :disabled="resourceForm.province!='' ? false : true"
                       :style="resourceForm.province!=110000 && resourceForm.province!=120000 && resourceForm.province!=500000 && resourceForm.province!=310000 ? 'width: 12vw;margin-right: 56px;' : 'width: 17.04vw;'">
              <el-option v-for="item1 in cityItem" :label="item1.name" :value="item1.id"/>
            </el-select>
            <el-select v-model="resourceForm.district" placeholder="请选择" clearable @change="changeDistrict"
                       :disabled="resourceForm.city!='' ? false : true"
                       :style="resourceForm.province!=110000 && resourceForm.province!=120000 && resourceForm.province!=500000 && resourceForm.province!=310000 ? 'width: 12vw;' : 'display:none;'">
              <el-option v-for="item2 in districtItem" :label="item2.name" :value="item2.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址:" prop="address">
            <el-input v-model="resourceForm.address" style="width: 100%"/>
          </el-form-item>
          <el-form-item label="服务类别:" prop="serviceType" class="resource-checkbox">
            <el-checkbox-group v-model="resourceForm.serviceType">
              <el-checkbox v-for="item of serviceTypeItem" :label="item.label" :value="item.value"></el-checkbox>
            </el-checkbox-group>
            <el-input :style="!isSelected ? 'display:none' : ''" v-model="resourceForm.other" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="企业简介:">
            <el-input v-model="resourceForm.introduction" style="width: 100%" maxlength="1000" type="textarea"
                      :autosize="{ minRows: 3, maxRows: 12}"/>
          </el-form-item>
          <el-form-item label="营业执照:" prop="fileList" class="el-upload-form">
            <el-upload action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg" :limit="9"
                       ref="upload" list-type="picture-card" :file-list="fileList" :on-exceed="handleExceed"
                       :multiple="true"
                       :on-success="successUpload" accept=".png,.jpeg,.jpg,.pdf" :on-preview="handlePictureCardPreview"
                       :on-remove="handleRemove">
              <i class="el-icon-plus"><span class="upload-text">上传附件</span></i>
            </el-upload>
          </el-form-item>
          <el-form-item style="margin-top: 50px;">
            <el-button type="primary" @click="submitForm">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import {isEmail, isMobile, isMoney, isPositiveInteger} from "@/common/tools";
import provincialCode from "@/static/marketCityList.json";
import {pyfdAppSaveSmesRResourcePool} from "@/api/pySystemApi";
export default {
  name: "resourcePoolSystem",
  components: {headerIndex, home_footer, Hang},
  data() {
    const checkPhone = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入手机'));
      } else if (!isMobile(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    }
    const checkMoney = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('年产值不能为空'));
      } else if (!isMoney(value)) {
        callback(new Error('请输入合法的金额数字，最多两位小数'));
      } else {
        callback();
      }
    }
    const PositiveInteger = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('企业人数不能为空'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入大于0的正整数'));
      } else {
        callback();
      }
    }
    const checkEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('电子邮箱不能为空'));
      } else if (!isEmail(value)) {
        callback(new Error('请输入合法的邮箱地址'));
      } else {
        callback();
      }
    }
    const checkCity = (rule, value, callback) => {
      if (this.resourceForm.province != '') {
        if (this.resourceForm.city != '') {
          if (this.resourceForm.province != 110000 && this.resourceForm.province != 120000 && this.resourceForm.province != 500000 && this.resourceForm.province != 310000) {
            if (this.resourceForm.district != '') {
              callback();
            } else {
              callback(new Error('请选择具体区县'));
            }
          } else {
            callback();
          }
        } else {
          callback(new Error('请选择二级注册地址'));
        }
      } else {
        callback(new Error('请选择一级注册地址'));
      }
    }
    const checkServiceType = (rule, value, callback) => {
      if (this.resourceForm.serviceType.length > 0) {
        let flag = this.resourceForm.serviceType.findIndex(item => item === '其他')
        if (flag != -1) {
          this.isSelected = true;
        } else {
          this.isSelected = false;
        }
        callback();
      } else {
        this.isSelected = false;
        callback(new Error('请勾选服务类别'));
      }
    }
    return {
      min_height: document.documentElement.clientHeight - 315,
      childNode: {},
      cid: 0,
      pName: '',
      fileList: [],
      inputWidth: 'auto',
      inputWidth2: 'auto',
      resourceForm: {
        businessName: '',
        legalPerson: '',
        legalPhone: '',
        contacts: '',
        phone: '',
        legalTelephone: '',
        telephone: '',
        money: '',
        employees: '',
        email: '',
        website: '',
        qq: '',
        zipCode: '',
        province: '',
        city: '',
        district: '',
        provinceName: '',
        cityName: '',
        districtName: '',
        address: '',
        serviceType: [],
        introduction: '',
        fileList: [],
        other:'',
      },
      provincialCodeItem: provincialCode,
      cityItem: [],
      districtItem: [],
      isSelected: false,
      serviceTypeItem: [
        {value: '政策咨询', label: '政策咨询'},
        {value: '融资担保', label: '融资担保'},
        {value: '财务审计', label: '财务审计'},
        {value: '法律服务', label: '法律服务'},
        {value: '知识产权', label: '知识产权'},
        {value: '报关服务', label: '报关服务'},
        {value: '对外交流', label: '对外交流'},
        {value: '翻译服务', label: '翻译服务'},
        {value: '培训机构', label: '培训机构'},
        {value: '人力资源', label: '人力资源'},
        {value: '网站建设', label: '网站建设'},
        {value: '软件设计', label: '软件设计'},
        {value: '广告设计', label: '广告设计'},
        {value: '展馆租赁', label: '展馆租赁'},
        {value: '会展会务', label: '会展会务'},
        {value: '物流仓储', label: '物流仓储'},
        {value: '机票酒店', label: '机票酒店'},
        {value: '汽车租赁', label: '汽车租赁'},
        {value: '水电气', label: '水电气'},
        {value: '其他', label: '其他'},
      ],
      rules: {
        businessName: [
          {required: true, message: '请输入企业名称', trigger: 'blur'},
          {min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur'}
        ],
        legalPerson: [
          {required: true, message: '请输入法定代表人', trigger: 'blur'},
          {min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur'}
        ],
        contacts: [
          {required: true, message: '请输入联系人', trigger: 'blur'},
          {min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur'}
        ],
        legalPhone: [
          {required: true, validator: checkPhone, trigger: 'blur'}
        ],
        phone: [
          {required: true, validator: checkPhone, trigger: 'blur'}
        ],
        money: [
          {required: true, validator: checkMoney, trigger: 'blur'}
        ],
        employees: [
          {required: true, validator: PositiveInteger, trigger: 'blur'}
        ],
        email: [
          {required: true, validator: checkEmail, trigger: 'blur'}
        ],
        website: [
          {required: true, message: '请输入企业网站', trigger: 'blur'},
        ],
        city: [
          {required: true, validator: checkCity, trigger: 'change'}
        ],
        address: [
          {required: true, message: '请填写详细地址', trigger: 'blur'},
        ],
        serviceType: [
          {type: 'array', required: true, validator: checkServiceType, trigger: 'change'}
        ],
        fileList: [
          {type: 'array', required: true, message: '请上传附件', trigger: 'change'}
        ]
      },
    }
  },
  methods: {
    /*监听注册地址修改*/
    changeProvincial(value) {
      for (let list of this.provincialCodeItem) {
        if (list.id == value) {
          this.resourceForm.city = '';
          this.resourceForm.districtName = '';
          this.resourceForm.cityName = '';
          if (value != 110000 && value != 120000 && value != 500000 && value != 310000) {
            this.resourceForm.provinceName = list.name;
            this.cityItem = list.children;
          } else {
            this.resourceForm.provinceName = list.children[0].name;
            this.cityItem = list.children[0].children;
          }
        }
      }
    },
    /*监听注册城市修改*/
    changeCity(value) {
      for (let list of this.cityItem) {
        if (list.id == value) {
          this.districtItem = list.children;
          this.resourceForm.district = '';
          this.resourceForm.districtName = '';
          this.resourceForm.cityName = list.name;
        }
      }
    },
    /*监听具体区县修改*/
    changeDistrict() {
      for (let list of this.districtItem) {
        if (list.id == value) {
          this.resourceForm.districtName = list.name;
        }
      }
    },
    /*上传图片成功处理*/
    successUpload(response, file, fileList) {
      this.resourceForm.fileList.push(response.imgPath);
    },
    /*图片在线预览*/
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible2 = true;
    },
    /*检索上传数量，限制上传9张*/
    handleExceed(files, fileList) {
      this.$message.error(`已超过上传上限！`);
    },
    /*图片删除*/
    handleRemove(file, fileList) {
      for (let i in this.resourceForm.fileList) {
        if (this.resourceForm.fileList[i] == file.response.imgPath) {
          this.resourceForm.fileList.splice(i, 1)
        }
      }
    },
    /*提交*/
    submitForm() {
      let can = 0;
      let formData = {};
      for (let a = 0; a < 5; a++) {
        this.$refs['resourceForm' + a].validate((valid) => {
          if (valid) {
          } else {
            can++;
            return false;
          }
        });
      }
      if (can == 0) {
        formData={
          companyName:this.resourceForm.businessName,
          legalPerson:this.resourceForm.legalPerson,
          corporatePhone:this.resourceForm.legalPhone,
          corporateOfficePhone:this.resourceForm.legalTelephone,
          contactPerson:this.resourceForm.contacts,
          contactPersonPhone:this.resourceForm.phone,
          contactOfficePhone:this.resourceForm.telephone,
          annualOutputValue:this.resourceForm.money,
          enterpriseSize:this.resourceForm.employees,
          corporateWebsite:this.resourceForm.website,
          email:this.resourceForm.email,
          qq:this.resourceForm.qq,
          postcode:this.resourceForm.zipCode,
          unitLocation:this.resourceForm.provinceName+this.resourceForm.cityName+this.resourceForm.districtName,
          unitDetailsAddress:this.resourceForm.address,
          servicesType:this.resourceForm.serviceType.join(','),
          servicesOtherInput:this.resourceForm.other,
          introduction:this.resourceForm.introduction,
          businessLicenseImgList:this.resourceForm.fileList,
          xmsbUserId:this.cid!=0 ? this.cid : ''
        }
        pyfdAppSaveSmesRResourcePool({smesRResourcePool:JSON.stringify(formData),request:'form'}).then(res=>{
          if (res.code==200){
            this.$message.success(res.msg);
            this.$router.replace({
              path: '/cultivation/index',
              query: {
                city: this.childNode.cityCode,
                cityName: this.childNode.name,
                pName:this.childNode.name+'企业数字化服务云平台',
              }
            })
          }
        })
      }
    }
  },
  mounted() {
    this.inputWidth = ((this.$refs.resourceForm0.$el.clientWidth - 330) / 3);
    this.inputWidth2 = ((this.$refs.resourceForm0.$el.clientWidth - 330) / 2);
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.pName = this.$route.query.pName;
    if (sessionStorage.getItem('childNode')) {
      this.childNode = JSON.parse(sessionStorage.getItem('childNode'));
    }
  }
}
</script>
<style scoped>
.resource-container >>> .resource-content .resource-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #5D5D5D;
}
.resource-container >>> .resource-content .resource-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.resource-container >>> .resource-content .resource-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.resource-container >>> .resource-content .resource-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.resource-container >>> .resource-content .resource-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #5D5D5D;
  font-family: 'SourceHanSansCN';
}
.resource-container >>> .resource-content .resource-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}
.resource-container >>> .resource-content .resource-breadcrumb .el-breadcrumb__inner a,
.resource-container >>> .resource-content .resource-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #333333;
}
.resource-container >>> .el-upload-list--picture-card .el-upload-list__item {
  width: 73px;
  height: 73px;
}
.resource-container >>> .el-upload--picture-card {
  width: 73px;
  height: 73px;
  line-height: 73px;
  padding: 5px 5px;
  color: #1637FF;
}
.resource-container >>> .resource-content .el-upload-form .el-form-item__error {
  color: #F56C6C;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 130%;
  left: 0;
}
.resource-container >>> .resource-content .el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
.resource-container >>> .resource-content .resource-form {
  display: flex;
  justify-content: space-between;
}
.resource-container >>> .resource-content .resource-info .el-button--primary {
  color: #FFF;
  background-color: #1637FF;
  border-color: #1637FF;
  padding: 10px 55px;
  font-size: 18px;
  font-family: 'SourceHanSansCN';
}
</style>
<style scoped lang="scss">
.resource-container {
  background: #F2F3FB;

  .resource-content {
    .resource-breadcrumb {
      display: flex;
      justify-content: left;
      font-size: 14px;
      font-weight: 100;
      color: #333333;
      font-family: "SourceHanSansCN";
      padding: 10px 18%;
      background: #F2F3FB;
      min-width: 76rem;
    }

    .resource-info {
      background: #ffffff;
      padding: 30px 18%;
      min-width: 76rem;
      .resource-title {
        font-size: 24px;
        font-family: 'SourceHanSansCN';
        color: #333333;
        margin-block-start: 0px;
        cursor: pointer;
      }

      .upload-text {
        font-size: 14px;
        position: absolute;
        margin-top: 55px;
        margin-left: -40px;
        color: rgb(51, 51, 51);
      }
      .resource-checkbox{
        width: 60%;
      }
    }
  }
}
</style>